module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-1"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-1-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Chapter One")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-1-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Nadaum")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Middle East")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("9:30PM, Saturday, March 3rd")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("“W")]), _c('i', [_vm._v("here am I?”")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The last thing Candace Simmons remembered was sitting at the table in the cafeteria of the Faith Rescue Mission. She was sharing lunch with other volunteers after a morning spent fulfilling their community service requirements at a center in Birmingham, Alabama.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Why is it so dark?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Candace opened her eyes, her heart raced, thinking she was dreaming. She peered around the blackened area. Her head pounded as if her brain were trying to escape her skull. Echoes of moans sent chills up her spine. The stench of mildew caused her stomach to twist. Metal dragged on concrete as she lifted her hands in front of her face. She felt the warmth of her breath on her moist skin, but still couldn’t see. Heavy bands of cold slid down her arms causing tremors to course through her body.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Where am I?” a young woman’s voice cried out.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“What the hell is going on?” another female spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Candace’s eyes stung as a bright light flooded the dark space and a garage door rolled up followed by a chorus of women screaming.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Welcome home, my treasures,” a man with a thick accent greeted, his smooth tenor tone far too inviting for the occasion. “You are going to serve a great purpose. Get these women to my wives and begin the process,” he called out over his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A group of men wearing white robes and headpieces filed in, pulling the women up, some by their hair, others their arms. Candace watched in horror as the men yanked cloth bags over the women’s heads, laughing at their screams, cries, and protests.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Somebody help me,” she screamed just before her hair was yanked from behind. The world went completely dark.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018ed2aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-001.vue
// module id = 75
// module chunks = 0